import type { Action } from 'redux'
import type { StreamDefinition } from '../../signalr/types'
import { defaultGetParams as getParams } from '../../signalr/helpers'
import { userAddUser } from './actions'
import type { User } from './types'

export const fetchUserDefinition: StreamDefinition<[], User[], Action> = {
  method: 'GetUserData',
  strategy: 'switch',
  getParams,
  mapResponse: userAddUser,
  errorAction: 'users.fetchFail',
  cancelOn: []
}
